import { F, p, _, r as register } from "./hooks.module-Cc20K0Ba.js";
import { g, w } from "./preact.module-B5ZnQuyU.js";
const ProductNotifyMe = (props) => {
  const isVisibleProp = props.isVisible === "true";
  const product = JSON.parse(props.productData);
  const variantId = props.variantId;
  const variantSelect = F(null);
  const emailInput = F(null);
  const submitButton = F(null);
  const [isVisible, setIsVisible] = p(isVisibleProp);
  const closeModal = (event) => {
    var _a;
    event.preventDefault();
    const target = event.target || event.target.closest(".button");
    (_a = target == null ? void 0 : target.closest("uwp-product-notify-me")) == null ? void 0 : _a.setAttribute("is-visible", "false");
  };
  _(() => {
    if (isVisible !== isVisibleProp) {
      setIsVisible(isVisibleProp);
    }
  }, [props.isVisible, isVisible]);
  const handleSendToBIS = (data) => {
    const buttonElement = submitButton.current;
    buttonElement.textContent = data.status === "OK" ? window.themeVars.strings.product.notifyMeModalSuccess : window.themeVars.strings.product.notifyMeModalError;
    setTimeout(() => {
      buttonElement.textContent = "Notify Me";
    }, 1e3);
  };
  const sendToBIS = () => {
    const email = emailInput.current.value;
    const variantId2 = variantSelect.current.value;
    const productId = product.id;
    window.BIS.create(email, variantId2, productId).then(handleSendToBIS);
  };
  let productImage = product.featured_image;
  if (productImage === void 0) {
    productImage = product.images[0].src;
  }
  return /* @__PURE__ */ g(
    "div",
    {
      className: `product__notify-modal__container ${isVisible ? "active" : ""}`
    },
    /* @__PURE__ */ g("div", { className: "product__notify-modal__wrapper" }, /* @__PURE__ */ g("div", { className: "product__notify-modal__header" }, /* @__PURE__ */ g("h4", null, window.themeVars.strings.product.notifyMeModalTitle), /* @__PURE__ */ g(
      "button",
      {
        className: "product__notify-modal__close",
        onClick: closeModal,
        dangerouslySetInnerHTML: {
          __html: window.themeVars.icons.close
        }
      }
    )), /* @__PURE__ */ g("div", { className: "product__notify-modal__body" }, /* @__PURE__ */ g("div", { className: "product__notify-modal__image" }, /* @__PURE__ */ g("img", { src: productImage, alt: product.title }), /* @__PURE__ */ g("h2", { className: "product__notify-modal__title" }, product.title)), /* @__PURE__ */ g("p", { className: "product__notify-modal__text" }, window.themeVars.strings.product.notifyMeModalText), product.variants.length && /* @__PURE__ */ g(w, null, /* @__PURE__ */ g("p", null, window.themeVars.strings.product.notifyMeModalOption, ":"), /* @__PURE__ */ g(
      "select",
      {
        name: "Unavailable Variants",
        "data-variant": true,
        className: "product__notify-modal__select",
        ref: variantSelect,
        value: variantId
      },
      product.variants.map(
        (variant) => !variant.available && /* @__PURE__ */ g(
          "option",
          {
            key: variant.id,
            value: variant.id,
            selected: variant.id === variantId
          },
          variant.title
        )
      )
    )), /* @__PURE__ */ g("p", null, window.themeVars.strings.product.notifyMeModalEmail, ":"), /* @__PURE__ */ g(
      "input",
      {
        type: "email",
        name: "email",
        ref: emailInput,
        required: true,
        placeholder: "Email Address",
        className: "product__notify-modal__sign-up"
      }
    ), /* @__PURE__ */ g(
      "button",
      {
        className: "product__notify-modal__button btn btn-black",
        onClick: sendToBIS,
        ref: submitButton
      },
      window.themeVars.strings.product.notifyMeModalSubmit
    )))
  );
};
if (!customElements.get("uwp-product-notify-me")) {
  register(ProductNotifyMe, "uwp-product-notify-me", [
    "is-visible",
    "variant-id"
  ]);
}
